import { forwardRef } from 'react';

import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';

import type { TInputProps } from './input.interface';

import './invoice-input.scss';

export const InputInvoice = forwardRef<HTMLInputElement, TInputProps>(
  (
    {
      label,
      name,
      error,
      disabled = false,
      color = 'default',
      type = 'text',
      endIcon,
      autoComplete = 'off',
      size = 'medium',
      example = '',
      labelSize = 'body2',
      labelWeight = 'semibold',
      onFocus,
      onBlur,
      ...props
    }: TInputProps,
    forwardRef
  ) => {
    let inputClass = '';
    if (error) {
      inputClass = 'co-border-error-main co-bg-common-white';
    } else {
      if (color === 'success') {
        inputClass =
          'co-border-pds-success-500 focus:co-border-pds-primary-500 focus:co-border-2';
      } else {
        inputClass =
          'co-border-pds-neutral-300 focus:co-border-pds-primary-500 focus:co-border-2';
      }
    }

    function createSize(): string {
      if (size === 'large') {
        return 'co-h-56px';
      }
      if (size === 'medium') {
        return 'co-h-[44px]';
      }
      return 'co-h-40px';
    }
    return (
      <div className="co-flex co-input-item co-flex-wrap">
        <label
          className={`
                        co-flex-1
                        co-relative
                        co-m-0
                        co-pl-0
                        co-label-${size}
                    `}
          htmlFor={name}
        >
          <input
            autoComplete={autoComplete}
            disabled={disabled}
            className={`
                        ${inputClass}
                        co-input-text-${size}
                        co-px-16px
                        co-w-full
                        co-text-[14px]
                        ${createSize()}
                        co-border-1
                        co-rounded-lg
                        co-font-semibold
                    `}
            type={type}
            name={name}
            id={name}
            placeholder={name}
            ref={forwardRef}
            onFocus={onFocus}
            onBlur={onBlur}
            {...props}
          />
          <span
            className={`
                        co-text-common-default
                        co-px-8px
                        co-rounded-lg
                        ${disabled ? 'co-bg-transparent' : 'co-bg-common-white'}
                        co-absolute
                        co-left-8px
                    `}
          >
            <Typography size={labelSize ?? 'body1'} weight={labelWeight} noWrap>
              {label}
            </Typography>
          </span>
          {endIcon && (
            <div
              className={`
                            ${createSize()}
                            co-flex
                            co-justify-center
                            co-items-center
                            co-h-auto
                            co-absolute
                            co-top-0
                            co-right-[12px]
                            co-bg-transparent`}
            >
              {endIcon}
            </div>
          )}
        </label>
        {example && (
          <div className="co-w-full co-pl-8px">
            {typeof example === 'string' ? (
              <Typography color="gray" size="body2" weight="medium">
                {example}
              </Typography>
            ) : (
              example
            )}
          </div>
        )}
        {error && (
          <div className="co-w-full">
            {typeof error === 'string' ? (
              <Typography size={labelSize ?? 'body1'} color="error">
                {error}
              </Typography>
            ) : (
              error
            )}
          </div>
        )}
      </div>
    );
  }
);
